import React, { useEffect, useState } from 'react'
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth'
import { auth } from '../firebase' // Import the auth instance
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

const EmailVerificationPage = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    // Check if the URL is a valid email verification link
    if (isSignInWithEmailLink(auth, window.location.href)) {
      // Retrieve the email from localStorage or prompt the user to enter their email again
      const storedEmail = window.localStorage.getItem('emailForRegistration')

      if (storedEmail) {
        setEmail(storedEmail)
      } else {
        // Optionally, prompt user to enter their email again
        toast.error('Email not found! Please enter your email again.')
        navigate('/register') // Redirect to the registration page
      }

      // Mark the loading state as complete
      setLoading(false)
    } else {
      // If the URL is invalid or not a sign-in link, handle appropriately
      toast.error('Invalid verification link')
      setLoading(false)
    }
  }, [])

  const handleVerification = (e) => {
    e.preventDefault()

    // Complete the email verification process using the sign-in link
    signInWithEmailLink(auth, email, window.location.href)
      .then(() => {
        toast.success('Email verified successfully!')
        navigate('/register') // Redirect to your registration page after verification
      })
      .catch((error) => {
        toast.error('Failed to verify email: ' + error.message)
      })
  }

  if (loading) {
    return <div>Loading...</div> // Show loading while checking the link
  }

  return (
    <div>
      <h1>Verify Your Email</h1>
      <p>A verification email has been sent to {email}</p>

      {/* Verification form */}
      <form onSubmit={handleVerification}>
        <button type="submit">Verify Email</button>
      </form>
    </div>
  )
}

export default EmailVerificationPage
